'use client';

import { createGlobalStyle, styled } from 'styled-components';
import { WistiaChannel } from '@wistia/react-embeds';

type ChannelProps = {
  /** 10 character hash ID of the media */
  hashedId: string;

  /** Optional class name, nesc. for extending as a styled-component */
  className?: string;
};

const ChannelWrapper = styled.div`
  overflow: hidden;
`;

/**
 * TODO: Remove this short-term work-around when product is updated
 * to provide in-channel transparent embeds.
 */
const ChannelTheme = createGlobalStyle`
  .w-gallery-view {
    background: none !important;
  }

  .w-gallery-view__section,
  .w-gallery-view__gallery-card-cover {
    background-image: none !important;
  }
`;

const Channel = ({ hashedId, className }: ChannelProps) => {
  return (
    <ChannelWrapper className={className}>
      <ChannelTheme />
      <WistiaChannel hashedId={hashedId} />
    </ChannelWrapper>
  );
};

export default Channel;
